import React from "react";
import { Link } from "react-router-dom";
import Icon from "../../../components/Library/Icon";

import styles from "./NotFound.css";

export default function NotFound() {
  return (
    <div className={styles.root}>
      <Icon name="confused-person" description="Confused person image" path="img" className={styles.icon}/>
      <div className={styles.description}>
        404! In other words, something went wrong.
      </div>
      <Link to="/" className={styles.button}>Read top stories</Link>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/dashboard/components/NotFound/NotFound.js